module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Angle-left-36ed1c5bcd1ceb6f3f595c9b2a420c17.svg";